// Third-party imports
import $ from 'jquery';

// Local imports
import * as flash from '../util/flash.js';

export function initialize(global) {
    whenScrolling(global, () => {
        if (sponsorFlashIsHidden()) {
            if (isScrolledPassed()) {
                let dataDiv = $('.sponsorship-data');
                let meetChildText = dataDiv.data('meet_child_bar');
                let a_cls =
                    'smoothScroll textLink textLink--alternate ' +
                    'textLink--arrowUp';
                let meetChildBar = `
                    <a href="#filtersBlock" class="${a_cls}">
                        ${meetChildText}
                    </a>
                `;
                flash.content(meetChildBar, 'meet', () => {});
                flash.show();
            } else {
                flash.hide();
            }
        }
    });
}

function whenScrolling(global, cb) {
    $(global).scroll(cb);
}

function sponsorFlashIsHidden() {
    return flash.getName() !== 'sponsor';
}

function isScrolledPassed() {
    let topOfSponsorshipSlider = $('#sponsorPage').offset().top;
    let ret =
        $(window).scrollTop() > topOfSponsorshipSlider &&
        topOfSponsorshipSlider > 0;
    return ret;
}
